'use strict';

var svaneTvis = svaneTvis || {};
svaneTvis.navigation = svaneTvis.navigation || new function () {
    this.init = function () {
        var navButton = document.querySelector('.js-mobile-navigation-button');
        var closeButton = document.querySelector('.js-mobile-close-button');
        var body = document.querySelector('body');

        if (!navButton && !closeButton) {
            return;
        }

        // Open mobile navigation
        navButton.addEventListener('click', function () {
            body.classList.toggle('mobile-navigation-open');
        }, true);

        // Close
        closeButton.addEventListener('click', function () {
            if (body.classList.contains('mobile-navigation-open')) {
                body.classList.remove('mobile-navigation-open');
            }
        }, true);

        // SmoothScrolling for shopnavigation
        var shopNavigation = document.querySelector('.js-shop-page-navigation');
        if (shopNavigation) {
            var scrollTriggers = document.querySelectorAll('.js-shop-page-navigation a[href*="#"]');
            if (scrollTriggers != null) {
                for (var i = 0; i < scrollTriggers.length; i++) {
                    let scrollTrigger = scrollTriggers[i];
                    let target = scrollTrigger.hash;
                    target = document.querySelector(target);
                    scrollTrigger.addEventListener('click', function (e) {
                        e.preventDefault();
                        window.scrollTo({
                            'behavior': 'smooth',
                            'left': 0,
                            'top': target.offsetTop - 40
                        });
                    }, true);
                }
            }
        }
    };
}();
